import classes from "app/css/widgets/Message.module.less";
import locale from "common/managers/locale";

function styleForType(type) {
    let cssClass = classes.error;
    let icon = "v";
    let iconClass= classes.errorIcon;
    let title = "error.title";
    if(type === "info") {
        cssClass = classes.info;
        iconClass = classes.infoIcon;
        icon = "i";
        title = "main.documentInformation.title";
    } else if(type === "warning") {
        cssClass = classes.warning;
        iconClass = classes.warningIcon;
        title = "warning";
        icon = "w";
    } else if(type === "success") {
        cssClass = classes.success;
        iconClass = classes.successIcon;
        title = "request.success"
        icon = "y";
    }
    return {
        cssClass,
        icon,
        iconClass,
        title: locale.get(title)
    };
}

function $icon(type) {
    const {icon, iconClass, title} = styleForType(type);
    const $iconWrapper = $("<span>").attr("title", title);
    const $icon = $("<span>").addClass(iconClass).attr("aria-hidden", "true").text(icon);
    $iconWrapper.append($icon);
    return $iconWrapper;
}

export function iconHTML(type) {
    return $("<div>").append($icon(type)).html();
}

function messageClasses(type) {
    return `${styleForType(type).cssClass} ${classes.message}`;
}

/**
 * This enhances a given element to make it look like the Message widget.
 * This is useful in scenarios where it's not possible or convenient to use the message widget, but it needs to look the same.
 * @param $element jquery element to enhance
 * @param type One of "error", "warning", "info", or "success"
 */
export function applyMessageStyle($element, type) {
    $element.addClass(messageClasses(type));
    $element.prepend($icon(type));
}
